import React from "react";
import classNames from "classnames";
// eslint-disable-next-line no-restricted-imports, import/named
import { Button as BSButton } from "react-bootstrap";
import { Spinner } from "banco-components/Library/atoms/Spinner/Spinner";

export type BancoButtonProps = React.ComponentProps<typeof BSButton> & {
  submitting?: boolean;
  type?: "submit" | "reset" | "button";
};

export const Button: React.FC<BancoButtonProps> = ({
  submitting = false,
  disabled = false,
  type = "button",
  className,
  children,
  ...props
}) => {
  const combinedClassName = classNames(
    "justify-content-center align-items-center",
    className
  );

  const contentStyle: React.CSSProperties = {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  };

  const spinnerStyle: React.CSSProperties = {
    visibility: submitting ? "visible" : "hidden",
    position: "absolute",
  };

  const childrenStyle: React.CSSProperties = {
    visibility: submitting ? "hidden" : "visible",
  };

  return (
    <BSButton
      className={ combinedClassName }
      type={ type }
      disabled={ submitting || disabled }
      { ...props }
    >
      <span style={ contentStyle }>
        <Spinner style={ spinnerStyle } className="mr-1" size="sm" />
        <span style={ childrenStyle }>{ children }</span>
      </span>
    </BSButton>
  );
};
